import Layout from "../Pages/AppLayout";

export function appLayout({ title, returnHref }) {
  return function (h, child) {
    return h(Layout, { title, returnHref }, [child]);
  };
}